var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 4.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.956 5.06003C12.0165 5.14717 12.0165 5.27788 11.9439 5.35049L6.62803 10.9419C6.59171 10.971 6.55538 11 6.51905 11C6.48273 11 6.43429 10.9855 6.41007 10.9564L4.06092 8.51654C3.98827 8.44393 3.97616 8.31322 4.04881 8.22608C4.10936 8.13894 4.21834 8.12442 4.29099 8.21156L6.51905 10.5207L11.7259 5.06003C11.7865 4.97289 11.8955 4.98742 11.956 5.06003Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFill);
export default __webpack_public_path__ + "static/media/checkbox-fill.f3857c0768c8f9f38ff0af74b5552553.svg";
export { ForwardRef as ReactComponent };